/**
 * @method：getFitRows
 * @createdBy:HuangJian
 * @date:2019/11/8
 * @params：
 * @description：获取适配行数
 */
export function getFitRows(){
    const vHeight =  window.innerHeight
        || document.documentElement.clientHeight
        || document.body.clientHeight;

    let refHeight = 0.7 * vHeight;

    refHeight -= 240;

    let rows = Math.round(refHeight /32/5)*5;

    rows = rows<10 ? 10:rows;

    return [
        rows,
        rows * 2,
        rows * 3,
        rows * 4,
        rows * 5
    ]
}

export {default} from './lnk-picklist'
